import { createTRPCReact } from "@trpc/react-query";
// During the migration both type sources resolve to the same router shape.
// In production CF Pages builds, set the build-time env so the bundle pulls
// the Worker types instead of the legacy Express routers:
//   VITE_USE_CLOUDFLARE_API=1 -> imports from cloudflare/api/src/router.ts
import type { AppRouter } from "../../../server/routers";

export const trpc = createTRPCReact<AppRouter>();
